import { initializeApp } from "firebase-v9/app";
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where
} from "firebase-v9/firestore";
import firebaseConfig from "./config";

let app
if (firebaseConfig) {
  app = initializeApp(firebaseConfig)
}

const db = getFirestore();
const collectionRef = collection(db, "users");
const fetchPromiseRef = { promise: null };

export const getStudentsFromV9 = async () => {
  try {
      if (!fetchPromiseRef.promise) {
      fetchPromiseRef.promise = (async () => {
        const q = query(collectionRef, where("studentId", "!=", null));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      })();
    }
    return fetchPromiseRef.promise; 
  }
  catch (error) {
      console.error("Error fetching students:", error);
  }
};
